import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getIdCertificado } from '@/auth/auth.utils'

/**
 * Resuelve las redirecciones del guard de autenticación.
 * Renderiza children solo cuando no hay redirección pendiente.
 */
export default function RedirectFallback({
  loading,
  auth,
  pathname,
  normalizedPathname,
  requiereIdCertificado,
  idcertificadoUrl,
  storeIdCertificado,
  children,
}) {
  if (loading) return null

  if (auth && pathname === '/login') {
    return <Navigate to="/" replace />
  }

  if (!auth && pathname !== '/login') {
    return <Navigate to="/login" replace />
  }

  if (auth && normalizedPathname === '/' && requiereIdCertificado) {
    const hayCertificado = idcertificadoUrl || storeIdCertificado || getIdCertificado()

    if (!hayCertificado) {
      console.info('🔒 Redirigiendo a / por falta de idCertificado')
      return <Navigate to="/" replace />
    }
  }

  return children
}

RedirectFallback.propTypes = {
  loading: PropTypes.bool.isRequired,
  auth: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
  normalizedPathname: PropTypes.string.isRequired,
  requiereIdCertificado: PropTypes.bool.isRequired,
  idcertificadoUrl: PropTypes.number,
  storeIdCertificado: PropTypes.number,
  children: PropTypes.node.isRequired,
}
